import Polyline from '@arcgis/core/geometry/Polyline';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import Graphic from '@arcgis/core/Graphic';
import { GroundPoint } from './GroundPoint';
import * as esriSymbols from '../resources/esriSymbols';
import Point from '@arcgis/core/geometry/Point';

export class SurfaceBreakline {
  readonly breaklineId: string | undefined;
  readonly eft_type: string = 'SurfaceBreakline';
  readonly groundPoints: GroundPoint[] = [];

  constructor(breaklineId?: string | undefined) {
    this.breaklineId = breaklineId;
  }

  generateGeometry(spatialReference: SpatialReference): Polyline {
    if (this.groundPoints.length < 2) {
      throw new Error('Invalid operation. The breakline has fewer than 2 points.');
    }

    const path: Point[] = [];
    for (const breaklinePoint of this.groundPoints) {
      const point = breaklinePoint.generateGeometry(spatialReference);
      path.push(point);
    }

    const result = new Polyline();
    result.spatialReference = spatialReference;
    result.hasZ = true;
    result.addPath(path);

    return result;
  }

  generateGraphic(spatialReference: SpatialReference): Graphic {
    const geometry = this.generateGeometry(spatialReference);
    const graphic = new Graphic({ geometry: geometry, symbol: esriSymbols.breaklineSymbol });
    graphic.attributes = this;
    return graphic;
  }
}
